(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks-wager/assets/javascripts/use-observed-draw-result.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks-wager/assets/javascripts/use-observed-draw-result.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useRef = _React.useRef,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useContext = _React.useContext,
  useCallback = _React.useCallback;
const log = svs.core.log;
const logger = log.getLogger('tipsen:hooksWager:useObservedDrawResult');
const _RTK = RTK,
  nanoid = _RTK.nanoid;
const useDrawResultFromCurrentWagerDraw = svs.components.tipsen.hooksWager.useDrawResultFromCurrentWagerDraw;

const createObserverOrchestrator = _ref => {
  let onUpdate = _ref.onUpdate,
    _ref$immediate = _ref.immediate,
    immediate = _ref$immediate === void 0 ? true : _ref$immediate;
  let observers = [];
  const lateObservers = [];
  let latestBroadcastedEvent = null;
  let isRunning = false;
  const callbackMap = {};
  const queue = [];
  const updateCurrent = event => {
    onUpdate(event);
    latestBroadcastedEvent = event;
  };
  const runObservers = function (_observers, event) {
    let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
    for (const observer of _observers) {
      observer.callback(event, callback);
    }
  };
  const unobserve = _ref2 => {
    var _callbackMap$uuid;
    let fn = _ref2.observer,
      uuid = _ref2.uuid;
    (_callbackMap$uuid = callbackMap[uuid]) === null || _callbackMap$uuid === void 0 || _callbackMap$uuid.call(callbackMap);
    observers = observers.filter(observer => observer.callback !== fn);
    delete callbackMap[uuid];
  };
  const observe = observer => {
    const uuid = nanoid();
    const newObserver = {
      uuid,
      callback: observer
    };
    observers.push(newObserver);

    if (isRunning) {
      lateObservers.push(newObserver);
    }
    if (!isRunning && latestBroadcastedEvent) {
      observer(latestBroadcastedEvent);
    }
    return () => unobserve({
      observer,
      uuid
    });
  };
  const run = () => {
    isRunning = true;
    const nextEvent = queue.shift();
    const observersCount = observers.length;
    const readyObservers = new Set();
    const onReadyCallback = _ref3 => {
      let uuid = _ref3.uuid;
      return () => {
        if (readyObservers.has(uuid)) {
          return;
        }
        readyObservers.add(uuid);
        if (readyObservers.size === observersCount) {
          updateCurrent(nextEvent);
          runObservers(lateObservers, nextEvent);
          lateObservers.length = 0;
          if (queue.length) {
            run();
          } else {
            isRunning = false;
          }
        }
      };
    };
    for (const observer of observers) {
      const onReady = onReadyCallback(observer);
      callbackMap[observer.uuid] = onReady;
      observer.callback(nextEvent, onReady);
    }
  };
  const broadcast = (event, forceReset) => {
    const observersCount = observers.length;
    if (immediate || !observersCount) {
      runObservers(observers, event);
      updateCurrent(event);
      return;
    }
    if (forceReset) {
      logger.debug("forced reset on orchestrator queue");
      updateCurrent([]);
      queue.length = 0;
    }
    queue.push(event);
    if (!isRunning) {
      run();
    }
  };
  return {
    observe,
    unobserve,
    broadcast
  };
};
const ObservedDrawResultContext = React.createContext();

const ObservedDrawResultProvider = _ref4 => {
  let children = _ref4.children,
    wagerId = _ref4.wagerId;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    currentValue = _useState2[0],
    setCurrentValue = _useState2[1];
  const previousDrawNumber = useRef();
  const onUpdate = useCallback(event => {
    setCurrentValue(event);
  }, []);
  const observerOrchestrator = useRef(createObserverOrchestrator({
    onUpdate,
    immediate: false
  }));

  const _useDrawResultFromCur = useDrawResultFromCurrentWagerDraw({
      wagerId
    }),
    _useDrawResultFromCur2 = _slicedToArray(_useDrawResultFromCur, 2),
    result = _useDrawResultFromCur2[0],
    drawNumber = _useDrawResultFromCur2[1];


  const isError = Boolean(result.error);
  useEffect(() => {
    if (!previousDrawNumber.current) {
      previousDrawNumber.current = drawNumber;
    }
    const hasChangedDrawNumber = previousDrawNumber.current && drawNumber !== previousDrawNumber.current;
    const hasData = result.data.some(v => Array.isArray(v) ? v.length > 0 : v);
    if (!hasData && !isError && !hasChangedDrawNumber) {
      return;
    }
    if (hasChangedDrawNumber && hasData) {
      previousDrawNumber.current = drawNumber;
    }
    observerOrchestrator.current.broadcast(result.data, hasChangedDrawNumber);
  }, [result.data, drawNumber, isError]);
  const contextValue = useMemo(() => ({
    observe: observerOrchestrator.current.observe,
    current: currentValue
  }), [currentValue]);
  return React.createElement(ObservedDrawResultContext.Provider, {
    value: contextValue
  }, children);
};

const useObservedDrawResult = () => {
  const observedContext = useContext(ObservedDrawResultContext);
  if (!observedContext) {
    throw new Error('useObservedDrawResult could not be used without a mounted ObservedDrawResultContext.Provider');
  }
  return observedContext;
};
setGlobal('svs.components.tipsen.hooksWager', {
  ObservedDrawResultProvider,
  useObservedDrawResult,
  createObserverOrchestrator
});

 })(window);